import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { supabase } from '@/integrations/supabase/client'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Generate a slug from team name
export const generateTeamSlug = (teamName: string): string => {
	return teamName
		.toLowerCase()
		.trim()
		.replace(/[^a-z0-9\s-]/g, '') // Remove special characters except spaces and hyphens
		.replace(/\s+/g, '-') // Replace spaces with hyphens
		.replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
		.replace(/^-|-$/g, '') // Remove leading/trailing hyphens
}

// Check if slug is unique and generate a unique one if needed
export const generateUniqueTeamSlug = async (baseSlug: string): Promise<string> => {
	let slug = baseSlug
	let counter = 1

	while (true) {
		const { data, error } = await supabase
			.from('teams')
			.select('id')
			.eq('slug', slug)
			.limit(1)

		if (error) throw error

		if (!data || data.length === 0) {
			// Slug is unique
			return slug
		}

		// Slug exists, try with counter
		slug = `${baseSlug}-${counter}`
		counter++
	}
}
